import InputHelperBootstrap from "../../../helper/InputHelperBootstrap"
import SelectHelper from "../../../helper/SelectHelper"
import * as VhfLang from "../VhfLang";
import { useNavigate, useLocation } from "react-router-dom";
import { useState,useEffect } from "react";


import { useForm,setValue } from "react-hook-form";
import * as Const from "../../../common/const"
import {
    Container,
    Form,
    Button,
    Row,
    Col,
    Dropdown,
    DropdownButton
    // InputGroup,
    // FormControl
  } from "react-bootstrap";
  import StepperHelper from "../../../helper/stepperHelper/StepperHelper"


const GetDistrict=(register,errors,setValue)=>{

  var shipClass=sessionStorage.getItem(VhfLang.ShipClassId);

  if(shipClass===Const.shipClassIdFishingShip){
    return<InputHelperBootstrap register={register(VhfLang.DistrictId, 
      { required: true})} error={errors[VhfLang.DistrictId]} id={VhfLang.DistrictId} label={VhfLang.DistrictLabel}   errorRequiredText={VhfLang.DistrictLabelError}   ></InputHelperBootstrap>
  }
  setValue(VhfLang.DistrictId,null);

}

const GetCallsign=(register,errors,setValue,shipsizeLength)=>{

  var shipClass=sessionStorage.getItem(VhfLang.ShipClassId);


  if(!Const.callsignReqFor.includes(shipClass)||parseInt(shipsizeLength)>=Const.MinBoatSizeLengthForLeisureBoatAndDisplayCallsign){

    return<InputHelperBootstrap register={register(VhfLang.CallsignId, 
      { required: true})} error={errors[VhfLang.CallsignId]} id={VhfLang.CallsignId} label={VhfLang.CallsignLabel}   errorRequiredText={VhfLang.CallsignLabel}   ></InputHelperBootstrap>
  }
  setValue(VhfLang.CallsignId,null);
}
 


  


const ShipInfo = () => {
    const {state} = useLocation();

    const [preventSubmit, setPreventSubmit] = useState('1');
    const [showErrorSelect, setShowErrorSelect] = useState('0');
    const [showDistrict,setShowDistrict]=useState(false);
    const [shipSizeLength,setShipSizeLength]=useState(0);
    const [shouldRegisterSjoFartverketEpirb1215Id,setShouldRegisterSjoFartverketEpirb1215Id]=useState(false);
    const [shouldRegisterSjoFartverketEpirb406Id,setShouldRegisterSjoFartverketEpirb406Id]=useState(false);



    const navigate = useNavigate();
    
    const {
        setValue ,
        register,
        handleSubmit,
        watch,
        getValues,
        formState: { errors }
      } = useForm();


      useEffect(() => {
           //set values from session storage
           var values=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForShipInfo));
           if(values!=null){
             setValue(VhfLang.ShipNameId,values[VhfLang.ShipNameId]) 
             //setValue(VhfLang.BoatSizeWidthId,values[VhfLang.BoatSizeWidthId]) 
             setValue(VhfLang.DistrictId,values[VhfLang.DistrictId]) 
             setValue(VhfLang.CallsignId,values[VhfLang.CallsignId]) 
     
             setValue(VhfLang.BoatSizeLengthId,values[VhfLang.BoatSizeLengthId]) 
             setValue(VhfLang.MmsiId,values[VhfLang.MmsiId]) 
             setValue(VhfLang.Epirb1215Id,values[VhfLang.Epirb1215Id]) 
             setValue(VhfLang.Epirb406Id,values[VhfLang.Epirb406Id]) 
     
             setValue(VhfLang.EpirbCheckboxLabel406,values[VhfLang.EpirbCheckboxLabel406]) 
             setValue(VhfLang.AISCheckboxId,values[VhfLang.AISCheckboxId]) 
             setValue(VhfLang.HandheldCheckBoxId,values[VhfLang.HandheldCheckBoxId]) 
  
             setValue(VhfLang.UseForMarketingId,values[VhfLang.UseForMarketingId]) 
             setValue(VhfLang.CommentId,values[VhfLang.CommentId]) 

             setShouldRegisterSjoFartverketEpirb1215Id(values[VhfLang.Epirb1215Id]);
             setShouldRegisterSjoFartverketEpirb406Id(values[VhfLang.Epirb406Id]);
             
         }
       
      },[])
  
      

       const onError = (values,target) => {
         setShowErrorSelect('1');
        } 


        const onChangeShipSizeLength = (e) => {
          setShipSizeLength(e.target.value);
        }

        const onChangeShouldRegisterSjoFartverketEpirb1215Id=(e)=>{
          setShouldRegisterSjoFartverketEpirb1215Id(e.target.checked);
        }
        const onChangeShouldRegisterSjoFartverketEpirb406Id=(e)=>{
          setShouldRegisterSjoFartverketEpirb406Id(e.target.checked);
        }
      
      const onSubmit = (values) => {

        if(preventSubmit=='1'){
         setShowErrorSelect('1');
          return true; 
        } 
     
       sessionStorage.setItem(VhfLang.KeyForSessionForShipInfo, JSON.stringify(values));
        navigate(VhfLang.NavPreview,
        /* {
          state: {
            values,
            privateContact: {privateContactDataState}
          },
        }*/
        );
      };

      const goBack = () => {

        var isPrivateContact = sessionStorage.getItem(VhfLang.IsPrivateContact);
        var backNav = VhfLang.NavPrivateContactInfo;
        if (isPrivateContact == 'false') backNav = VhfLang.NavCompanyContactInfo;

        // Read serializable values from the form (fallback to sessionStorage)
        const currentValues = typeof getValues === 'function'
          ? getValues()
          : (JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForShipInfo)) || {});

        navigate(backNav, {
          state: {
            values: currentValues,
          },
        });
      };


   
      
    
    return(
        
        <Form onSubmit={handleSubmit(onSubmit,onError)}>
            <StepperHelper activeStep={2}></StepperHelper>
        <fieldset>
                  <legend></legend>
                  <h2>{VhfLang.ShipInfoLegendH2}</h2>
               
                  <InputHelperBootstrap register={register(VhfLang.ShipNameId, { required: true})} error={errors[VhfLang.ShipNameId]} id={VhfLang.ShipNameId} label={VhfLang.ShipNameLabelLang}  placeholder={VhfLang.ShipNameLang} errorRequiredText={VhfLang.ShipNameLang} ></InputHelperBootstrap>

                  <Row>
                    <Col>
                    <SelectHelper preventSubmitFunc={setPreventSubmit} alwaysShowError={showErrorSelect} key={showErrorSelect} label={VhfLang.ShipClassLabel} errorMessage={VhfLang.ShipClassError} chooseText={VhfLang.ShipClassError} validOptions={VhfLang.ValidOptions} id={VhfLang.ShipClassId} showDistrictFunc={setShowDistrict}></SelectHelper>
                    </Col>
                    <Col>
                      <InputHelperBootstrap register={register(VhfLang.BoatSizeLengthId, 
                        { required: true,pattern: Const.onlyDigits})} error={errors[VhfLang.BoatSizeLengthId]} id={VhfLang.BoatSizeLengthId} label={VhfLang.BoatSizeLengthLang}  placeholder={VhfLang.BoatSizeLengthLabelLang} errorRequiredText={VhfLang.BoatSizeLengthLabelLang}  errorPatternText={VhfLang.OnlyDigitsError} onChangeFunc={onChangeShipSizeLength} type={Const.typeTextWithOnChangeEvent} ></InputHelperBootstrap>
                  </Col>
                  </Row>

                  {GetDistrict(register,errors,setValue)}
                  {GetCallsign(register,errors,setValue,shipSizeLength)}

               
<br></br>
                  
                  <InputHelperBootstrap register={register(VhfLang.MmsiId, { required: false})} id={VhfLang.MmsiId}    type={Const.typeCheckBox} labelCheckBox={VhfLang.MmsiCheckboxLabel} ></InputHelperBootstrap>
                  <InputHelperBootstrap register={register(VhfLang.AISCheckboxId, { required: false})} id={VhfLang.AISCheckboxId}    type={Const.typeCheckBox} labelCheckBox={VhfLang.AISCheckboxLabel} ></InputHelperBootstrap>
                  <InputHelperBootstrap register={register(VhfLang.HandheldCheckBoxId, { required: false})} id={VhfLang.HandheldCheckBoxId}    type={Const.typeCheckBox} labelCheckBox={VhfLang.HandheldCheckBoxLabel} ></InputHelperBootstrap>
                  <InputHelperBootstrap register={register(VhfLang.Epirb1215Id, { required: false})} id={VhfLang.Epirb1215Id}  type={Const.typeCheckBoxWithChangeEvent} labelCheckBox={VhfLang.EpirbCheckbox1215IdLabel} onChangeFunc={onChangeShouldRegisterSjoFartverketEpirb1215Id} ></InputHelperBootstrap>
                  <InputHelperBootstrap register={register(VhfLang.Epirb406Id, { required: false})} id={VhfLang.Epirb406Id}    type={Const.typeCheckBoxWithChangeEvent} labelCheckBox={VhfLang.EpirbCheckboxLabel406} onChangeFunc={onChangeShouldRegisterSjoFartverketEpirb406Id}></InputHelperBootstrap>

              {(shouldRegisterSjoFartverketEpirb1215Id||shouldRegisterSjoFartverketEpirb406Id)&&<>{VhfLang.ShouldRegisterSjoFartverket}</>}

                 {sessionStorage.getItem(VhfLang.IsPrivateContact)==='true'&& 
                 <InputHelperBootstrap register={register(VhfLang.UseForMarketingId, { required: false})} id={VhfLang.UseForMarketingId}    type={Const.typeCheckBox} labelCheckBox={VhfLang.UseForMarketingLabel} defaultValue={true} ></InputHelperBootstrap>}
<br></br>

                  <InputHelperBootstrap register={register(VhfLang.CommentId, { required: false})} error={errors[VhfLang.CommentId]} id={VhfLang.CommentId} label={VhfLang.CommentLabel}  placeholder={VhfLang.CommentLabel}  type={Const.typeTextArea} rows={3} ></InputHelperBootstrap>


                  <div className="float-end">
                    <Button variant="back" type="button"  onClick={goBack} className="button-margin">
                      {VhfLang.ButtonPreviousDisplay}
                    </Button>
                    <Button variant="forward" type="submit" className="button-margin">
                      {VhfLang.ButtonNextDisplay}
                    </Button>
                  </div>
                  </fieldset>
        </Form>
    )
}
export default ShipInfo

//<InputHelperBootstrap register={register(VhfLang.BoatSizeWidthId, { required: true})} error={errors[VhfLang.BoatSizeWidthId]} id={VhfLang.BoatSizeWidthId} label={VhfLang.BoatSizeLengthLang}  placeholder={VhfLang.BoatSizeLengthLabelLang} errorRequiredText={VhfLang.BoatSizeLengthLabelLang} ></InputHelperBootstrap>